export const LOCALSTORAGE_ADDRESS = "address"
export const LOCALSTORAGE_COUNTRYCODE = "countryCode"
export const LOCALSTORAGE_PLACE = "place"
export const LOCALSTORAGE_ENTITYMAP = "entityMap"
export const LOCALSTORAGE_LOCATIONPERMISSION = "locationPermission"
export const LOCALSTORAGE_LAST_WEB_LOCATION_SYNC = "lastWebLocationSync"
export const LOCALSTORAGE_RESOLVED_PLACE = "resolvedLocationPlace"
export const LOCALSTORAGE_COMMUNITIES = "chaperon_user_communities"
export const LOCALSTORAGE_COMMUNITIES_FETCHED_AT =
    "chaperon_user_communities_fetched_at"
export const LOCALSTORAGE_MAP_STYLE = "mapStyle"
export const LOCALSTORAGE_LOCATION_REFRESH_MINUTES = "locationRefreshMinutes"
export const LOCALSTORAGE_COMMUNITY_SIDEBAR_OPEN = "communitySidebarOpen"

export const SESSIONSTORAGE_NEWS = "news"
export const SESSIONSTORAGE_LOCATION = "location"
export const SESSIONSTORAGE_ENTITY = "entity"
export const SESSIONSTORAGE_SPOTLIGHTS = "entitySpotlights"
export const SESSIONSTORAGE_REPORTS = "reports"
